
      function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLogoReset = props => /*#__PURE__*/React.createElement("svg", _extends({
  "data-name": "LockKey Icon",
  xmlns: "http://www.w3.org/2000/svg",
  width: 120,
  height: 120,
  viewBox: "0 0 120 120"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "logo-reset_85d811498f323021__a"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 1970",
  style: {
    fill: "none"
  },
  d: "M0 0h120v120H0z"
}))), /*#__PURE__*/React.createElement("g", {
  style: {
    clipPath: "url(#logo-reset_85d811498f323021__a)"
  }
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 1969",
  style: {
    fill: "none"
  },
  d: "M0 0h120v120H0z"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "LockKey"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3070",
  d: "M24.642 36.342A10.44 10.44 0 1 0 14.2 25.9a10.44 10.44 0 0 0 10.442 10.442z",
  transform: "translate(35.361 46.627)",
  style: {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    stroke: "var(--theme-primary, #810ea9)",
    fill: "none"
  }
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3071",
  d: "M16.7 20.462V32.99",
  transform: "translate(43.301 62.508)",
  style: {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    stroke: "var(--theme-primary, #810ea9)",
    fill: "none"
  }
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3072",
  d: "M93.4 11.462H9.878A4.176 4.176 0 0 0 5.7 15.638V74.1a4.176 4.176 0 0 0 4.178 4.18H93.4a4.176 4.176 0 0 0 4.178-4.18V15.638a4.177 4.177 0 0 0-4.178-4.176z",
  transform: "translate(8.363 33.923)",
  style: {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    fill: "none"
  }
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3073",
  d: "M12.2 40.047V21.254a18.793 18.793 0 0 1 37.586 0v18.793",
  transform: "translate(29.009 5.337)",
  style: {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    fill: "none"
  }
}))));

      const __svgRaw = "<svg data-name=\"LockKey Icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"120\" height=\"120\" viewBox=\"0 0 120 120\">\r\n    <defs>\r\n        <clipPath id=\"q59d31isma\">\r\n            <path data-name=\"Rectangle 1970\" style=\"fill:none\" d=\"M0 0h120v120H0z\"/>\r\n        </clipPath>\r\n    </defs>\r\n    <g style=\"clip-path:url(#q59d31isma)\">\r\n        <path data-name=\"Rectangle 1969\" style=\"fill:none\" d=\"M0 0h120v120H0z\"/>\r\n        <g data-name=\"LockKey\">\r\n            <path data-name=\"Path 3070\" d=\"M24.642 36.342A10.44 10.44 0 1 0 14.2 25.9a10.44 10.44 0 0 0 10.442 10.442z\" transform=\"translate(35.361 46.627)\" style=\"stroke-linecap:round;stroke-linejoin:round;stroke-width:4px;stroke:var(--theme-primary, #810ea9);fill:none\"/>\r\n            <path data-name=\"Path 3071\" d=\"M16.7 20.462V32.99\" transform=\"translate(43.301 62.508)\" style=\"stroke-linecap:round;stroke-linejoin:round;stroke-width:4px;stroke:var(--theme-primary, #810ea9);fill:none\"/>\r\n            <path data-name=\"Path 3072\" d=\"M93.4 11.462H9.878A4.176 4.176 0 0 0 5.7 15.638V74.1a4.176 4.176 0 0 0 4.178 4.18H93.4a4.176 4.176 0 0 0 4.178-4.18V15.638a4.177 4.177 0 0 0-4.178-4.176z\" transform=\"translate(8.363 33.923)\" style=\"stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:4px;fill:none\"/>\r\n            <path data-name=\"Path 3073\" d=\"M12.2 40.047V21.254a18.793 18.793 0 0 1 37.586 0v18.793\" transform=\"translate(29.009 5.337)\" style=\"stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:4px;fill:none\"/>\r\n        </g>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/logo-reset.85d811498f323021a805ee4c9d61f595.svg"),
        {
          React: SvgLogoReset,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      